/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import { useFormatters } from "../../hooks/useFormatters";
import { formatTime as formatTimeUtil } from "../../utils/helpers/formatters";

const FormatTime = ({ value, format }) => {
  const { FormatTime } = useFormatters();

  return FormatTime({ value, format });
};

FormatTime.FORMAT = formatTimeUtil.FORMAT;

export default FormatTime;
